import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-translation-section',
    templateUrl: './translation-section.component.html',
    styleUrls: ['./translation-section.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TranslationSectionComponent {
  @Input() section: any;
  @Input() sectionForm: any;
  @Input() originalLanguage: { languageCode: string, languageName: string };
  @Input() translationLanguage: { languageCode: string, languageName: string };

  initialValue: any;

  ngOnInit() {
    this.initialValue = this.sectionForm.get('translations').value;
  }

  getTranslationsForm(): FormArray {
    return this.sectionForm.get('translations') as FormArray;
  }

  getTranslationForm(translationIndex: number): FormGroup {
    return this.getTranslationsForm().at(translationIndex) as FormGroup;
  }

  getSectionForm(sectionIndex: number): FormGroup {
    return this.sectionForm.get('sections').at(sectionIndex) as FormGroup;
  }

  getSwitchAriaLabel(translation): string {
    return $localize `Switch to the original translation for ${translation.label}`;
  }

  getDeleteAriaLabel(translation): string {
    return $localize `Reset to the original translation for ${translation.label}`;
  }

  getConfirmedAriaLabel(translation): string {
    return $localize `Confirm translation for ${translation.label}`;
  }

  switchTranslation(translation, translationIndex: number) {
    this.getTranslationForm(translationIndex).setValue({
      msgStr: translation.msgId,
      confirmed: false
    });
  }

  toggleConfirmed(translationIndex: number) {
    const translationConfirmedForm = this.getTranslationForm(translationIndex).get('confirmed');
    translationConfirmedForm.setValue(!translationConfirmedForm.value);
  }

  resetTranslation(translationIndex: number) {
    this.getTranslationForm(translationIndex).reset(this.initialValue[translationIndex]);
  }
}
